import api from "./api.js";

export default class ReviewApi {
  // ---------- 상품-후기 ---------- //
  static async getList(params) {
    return await api.get(`api/review`, params);
  }

  static async delete(id) {
    return await api.del(`api/review/${id}`);
  }

  static async getById(id) {
    return await api.get(`api/review/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/review/${id}`, data);
  }

  static async updateActivation(id, data) {
    return await api.patch(`api/review/activation/${id}`, data);
  }

  static async getListReview(params) {
    return await api.get(`api/review`, params);
  }
}
